import { useCallback } from 'react';

import { useHttp } from '@publicisgroupe/p-os-components';
import { webframeApi } from 'api/webframeApi';

export const useGetClientProfiles = () => {
  const http = useHttp();

  return useCallback(
    async (url: string) => {
      if (!http) return { items: [], totalCount: 0 };

      const themes = await webframeApi(http)?.getClientProfiles(url);

      if (!themes?.data) return { items: [], totalCount: 0 };

      return themes.data;
    },
    [http]
  );
};
